import _ from 'lodash'
import React from 'react'
import { MdWarningAmber } from 'react-icons/md'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../decorators'
import { hasAdminRole } from '../../../selectors/user'
import { continueEncounterCheck, encounterSearch } from '../../Encounter/actions'
import { NarusChip } from '../../shared/NarusMaterial/NarusChip'

import './encounter-warning.scss'

class EncounterWarnings extends React.Component {
  constructor (props) {
    super(props)
    this.continueToEncounter = this.continueToEncounter.bind(this)
    this.continueEncounter = this.continueEncounter.bind(this)
  }

  continueEncounter (asUserId) {
    const { dispatch, params } = this.props

    if (asUserId && this.props.hasAdminRole) {
      localStorage.setItem('asUserId', asUserId)

      dispatch(encounterSearch(params.id, {}, params.clientName))

      dispatch(
        continueEncounterCheck(params.id, {}, asUserId, this.continueToEncounter, params.clientName)
      )
    }
  }

  continueToEncounter () {
    const { auth, params, navigate } = this.props

    const role = _.get(auth, 'profile.app_metadata.roles', [])[`${params.clientName}-compassion`]
    if (role === 'administrative_support') {
      navigate(
        `/patient/${params.clientName}/${params.id}/assessment/standarddemographicspatient`
      )
    } else {
      navigate(`/patient/${params.clientName}/${params.id}/assessment/igao`)
    }
  }

  renderOtherUserOpenEncounter () {
    const { encounter, patientFolder } = this.props
    const noHover = !this.props.hasAdminRole
    let otherEncounters = _.get(encounter, 'otherEncounters', []) ? _.get(encounter, 'otherEncounters', []) : []
    const mappedEncounters = []

    otherEncounters.forEach(enc => {
      const user = enc.document.user.user_metadata
      const otherEncounter = {
        displayName: `${user.given} ${user.family}${user.suffix?.length ? `, ${user.suffix[0]}` : ''}`,
        icon: enc.document.type,
        userId: enc.document.user.sub,
        time: enc.created_at
      }
      mappedEncounters.push(otherEncounter)
    })

    const user = _.get(encounter, 'encounter.document.user.user_metadata')
    if (encounter.encounter && user && otherEncounters.filter(enc => enc.author_id === encounter.encounter.author_id).length === 0) {
      const myEncounter = {
        myEncounter: true,
        displayName: `${user.given} ${user.family}${user.suffix?.length ? `, ${user.suffix[0]}` : ''}`,
        userId: encounter.encounter.document.user.sub,
        icon: encounter.encounter.document.type,
        time: encounter.encounter.created_at
      }
      mappedEncounters.unshift(myEncounter)
    }

    const otherMappedEncounters = mappedEncounters.filter(
      enc => enc.myEncounter !== true
    )

    return (
      <div>
        <div className='row middle-xs gap flex flex-row gap-3 flex-wrap'>
          <div className='warning-container'>
            <MdWarningAmber size='1.3rem' />
            <span className='warning-text'>
              Encounters in Progress
            </span>
          </div>
          {patientFolder
            ? mappedEncounters.map((enc, index) => (
              <button
                onClick={() => this.continueEncounter(enc.userId)}
                className='chip-margin'
                key={`EncounterWarningChip${index}`}
              >
                <NarusChip
                  disableHover={noHover}
                  icon={enc.icon}
                  time={enc.time}
                  text={`${enc.displayName}`}
                />
              </button>
            ))
            : otherMappedEncounters.map((enc, index) => (
              <div
                className='chip-margin'
                key={`EncounterWarningChip${index}`}
              >
                <NarusChip
                  disableHover
                  icon={enc.icon}
                  time={enc.time}
                  text={`${enc.displayName}`}
                />
              </div>
            ))}
        </div>
      </div>
    )
  }

  // renderPlaceholder () {
  //   return (
  //     <div
  //       className='warning-container'
  //       style={{ backgroundColor: '#f5f8e9' }}
  //     >
  //       <span
  //         className='warning-text'
  //         style={{ color: '#82a109' }}
  //       >
  //         No Other Encounters
  //         <br />in Progress
  //       </span>
  //     </div>
  //   )
  // }

  render () {
    const { users, encounter, auth, params } = this.props
    const sub = _.get(auth, 'profile.sub', [])

    let otherEncounters = (_.get(encounter, 'otherEncounters') ?? []).slice()

    let previousPatientIds = [
      encounter?.encounter?.subject_id,
      ...otherEncounters.map(enc => enc.subject_id)
    ]
      .filter(Boolean)
      .filter((v, i, a) => a.indexOf(v) === i)

    if (
      encounter.encounter &&
      encounter.encounter.author_id !== sub &&
      otherEncounters.filter(enc => enc.author_id === encounter.encounter.author_id).length === 0
    ) {
      otherEncounters.push(encounter.encounter)
    }

    if (!previousPatientIds.includes(params.id)) {
      return (
        <div />
      )
    }

    return (
      <div>
        {users && otherEncounters && otherEncounters.length > 0 &&
           this.renderOtherUserOpenEncounter()}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  users: redux.users,
  encounter: redux.encounter,
  patientFolder: redux.encounterNavBar.patientFolder,
  hasAdminRole: hasAdminRole(redux)
})

export default connect(mapStateToProps)(withLegacyRouter(EncounterWarnings))
